import React, { useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import ContactCard from "../ContactCard";

const ModalShowContact = ({ data }) => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  return (
    <dialog id="contact_modal" className="modal shadow-2xl">
      <div className="modal-box flex flex-col !bg-transparent !p-0 items-center justify-between !shadow-none max-w-none w-fit h-fit">
        <div className="flex flex-col gap-5 w-[100vw] md:w-[500px]">
          {data && (
            <ContactCard
              firstName={data.first_name}
              lastName={data.last_name}
              jobTitle={data.job_title}
              company={data.company}
              address={(() => {
                let addressData = data.contact_social.filter(
                  (val) =>
                    val.lookup_id == "LKPe0c77ceb40aa4054bf16a9221752acd8",
                );
                if (addressData.length > 0) {
                  return addressData[0].input_value;
                }
              })()}
              notes={data.notes}
              phones={data.contact_social
                .filter(
                  (val) =>
                    val.lookup_id == "LKP3cb4c0867b0f4a479b35b5bea1328fc3",
                )
                .map((val) => {
                  return {
                    phone: val.input_value,
                    label: "personal",
                  };
                })}
              emails={data.contact_social
                .filter(
                  (val) =>
                    val.lookup_id == "LKP8d00ffb749ce4cb4a26236888b7614e2",
                )
                .map((val) => {
                  return {
                    email: val.input_value,
                    label: "personal",
                  };
                })}
              tags={data.tags}
              imageSourceProfile={data.profile_image && data.profile_image.url}
            />
          )}
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button>close</button>
      </form>
    </dialog>
  );
};

export default ModalShowContact;
